module.exports = __webpack_public_path__ + "img/live-cast-img01.8a265cc9.png";